// extracted by mini-css-extract-plugin
module.exports = {"downloadFiles":"DownloadFiles_downloadFiles__Z3lXo","link":"DownloadFiles_link__6jL1H"};